import { useEffect, useState } from "react";
import { useAuth } from "@/context/AuthContext";

// Funnel model: anonymous visitors get ANON_FREE runs (a taste) → then must create a
// free Community account. Logged-in Community & Pro users are never hard-capped; Community
// gets soft "go Pro" nudges. Usage count is tracked per-tool in localStorage.
//
// AuthContext user: null = still checking, false = anonymous, object = signed in.
// We only treat `false` as anonymous so the anon hint/lock never flashes during auth hydration.
export const ANON_FREE = 1;

export function useToolGate(storeKey) {
  const { user } = useAuth();
  const authResolved = user !== null && user !== undefined;
  const isPro = !!(user && user.subscription_active);
  const isCommunity = !!user && !isPro;
  const isAnon = user === false;

  const [used, setUsed] = useState(0);
  const [hydrated, setHydrated] = useState(false);

  useEffect(() => {
    const stored = parseInt(localStorage.getItem(storeKey) || "0", 10);
    if (!isNaN(stored)) setUsed(stored);
    setHydrated(true);
  }, [storeKey]);

  const ready = authResolved && hydrated;
  const locked = ready && isAnon && used >= ANON_FREE;
  const anonFreeLeft = Math.max(0, ANON_FREE - used);

  const registerUse = () => {
    if (isAnon) {
      const next = used + 1;
      setUsed(next);
      localStorage.setItem(storeKey, String(next));
    }
  };

  return { user, isPro, isCommunity, isAnon, used, locked, anonFreeLeft, registerUse, ready };
}
